import { createFileRoute } from '@tanstack/react-router'

import { ConfigurationPage } from '@/components/configuration/configuration-page'

export const Route = createFileRoute('/configuration')({
  component: ConfigurationPage,
})
